import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import { CamposToFechaCorta } from '../../funciones/FuncionesFecha.js';
import { DescripcionFuente } from '../../funciones/FuncionesInformacion.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaLinks.module.css';

const TablaInformaciones = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;
  const subtitulo = props.subtitulo;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  const descripcionFuenteInformacion = (item) => {
    let descripcion = '';
    descripcion = item.fuenteInformacion
      ? DescripcionFuente(item.fuenteInformacion)
      : 'información';
    if (item.numeroFuente) {
      descripcion += ' ' + item.numeroFuente;
    }
    if (item.anioFuente) {
      descripcion +=
        ' (' + CamposToFechaCorta(item.anioFuente, item.mesFuente, item.diaFuente) + ')';
    }
    return descripcion;
  };

  return (
    <React.Fragment>
      <tr>
        <td colSpan="3" className={`${styles.subtitulo}`}>
          {subtitulo}
        </td>
      </tr>
      <tr key="0" className={`${styles.titulos}`}>
        <td className={`${styleCols.tipo}`}>Tipo</td>
        <td className={`${styleCols.fuente}`}>Fuente</td>
        <td className={`${styleCols.detalle}`}>Detalle</td>
      </tr>
      {lista.map((item) => (
        <tr className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`} key={item.id}>
          <td className={`${styleCols.tipo}`}>
            {item.tipoInformacion && item.tipoInformacion.descripcion}
          </td>
          <td className={`${styleCols.fuente}`}>{descripcionFuenteInformacion(item)}</td>
          <td className={`${styleCols.detalle}`}>{item.detalle}</td>
          <ColumnaBotoneraItem
            idItem={item.id}
            onEditarItem={onEditarItem}
            onEliminarItem={onEliminarItem}
          />
        </tr>
      ))}
    </React.Fragment>
  );
};

export default TablaInformaciones;
